import { actionKitImpFunction } from '../../../../components/ozmoit/common';
import { getStudentActions } from '../../actions/studentActions';

export const getStudentActionsAction = actionKitImpFunction(
  async (params: { studentId: string | number; sessionId?: number }) => {
    const response = await getStudentActions(params.studentId, {
      sessionId: params.sessionId,
    });
    if (response.error) {
      throw new Error('Error fetching student actions');
    }
    return response.data;
  },
);
